import React, { useState, useEffect } from 'react';
import { Input } from '../UI';

// ─────────────────────────────────────────────────────────────
// "Requested For" — the person a requisition is being raised on behalf of.
//
// Optional, and off by default: the overwhelming majority of requisitions are
// raised by the person they are for, and an always-open box invites people to
// type their own name into it, which would make the field meaningless.
//
// Shared by all three requisition forms so the tick-box rule cannot drift
// between them. The checkbox is derived state, not stored: a saved name means
// the box was ticked, so a draft reopens in the right state without the server
// having to remember a flag alongside the name it already has.
// ─────────────────────────────────────────────────────────────

export default function RequestedForField({ value, onChange, disabled = false }) {
  const [enabled, setEnabled] = useState(!!value);

  // A draft's saved name arrives after the first render, so the box has to
  // follow it rather than only reading it once on mount.
  useEffect(() => {
    if (value) setEnabled(true);
  }, [value]);

  const toggle = (checked) => {
    setEnabled(checked);
    // Clearing on untick is what makes the checkbox honest: leaving the name
    // behind would save a beneficiary the requester had just said was wrong.
    // "" rather than null so it survives the API's exclude_none and actually
    // clears the stored value.
    if (!checked) onChange('');
  };

  return (
    <div style={{ minWidth: 0 }}>
      <label style={{
        display: 'flex', alignItems: 'center', gap: 7, cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: 12, fontWeight: 700, color: 'var(--text-secondary)',
        marginBottom: 6, letterSpacing: 0.2, userSelect: 'none',
      }}>
        <input
          type="checkbox"
          checked={enabled}
          disabled={disabled}
          onChange={(e) => toggle(e.target.checked)}
          style={{ width: 14, height: 14, cursor: disabled ? 'not-allowed' : 'pointer', accentColor: '#0b318bff' }}
        />
        Requested For
      </label>
      <Input
        value={value || ''}
        onChange={onChange}
        disabled={disabled || !enabled}
        placeholder={enabled ? "Name of the person this is for" : 'Tick to raise on behalf of someone'}
      />
    </div>
  );
}
